import React from "react";
import { Col, FormControl, FormGroup, FormLabel, Row } from "react-bootstrap";
import { SubsetPreview } from ".";
import { InputBox } from "../../components";
import { PendingCommand, PlaylistMessageInterface } from "../../helpers";


interface Props {
  playlistMessage: PlaylistMessageInterface
  sendCommand: (cmd: PendingCommand) => void
}


export const Subset: React.FC<Props> = props => {

  const [playlistMessage, setPlaylistMessage] = React.useState<PlaylistMessageInterface>(null);
  const [startText, setStartText] = React.useState("1");
  const [endText, setEndText] = React.useState("1");


  const handleChange = (e: any) => {
    let pm: PlaylistMessageInterface = { ...playlistMessage };
    let val = e.currentTarget.value;

    switch (e.currentTarget.id) {
      case "startCount":
        setStartText(val);
        pm.childPlaylistStart = getIndex(val)
        break;
      case "endCount":
        setEndText(val);
        pm.childPlaylistEnd = getIndex(val)
        break;
    }
    setPlaylistMessage(pm);
  }


  const getIndex = (selectedValue: string) => {
    let valNum = Math.abs(parseFloat(selectedValue));
    if (isNaN(valNum) || valNum === 0) valNum = 1;
    //let fromEnd = currentIndex < 0 || currentIndex >= 999;
    //let result = (fromEnd) ? -valNum : valNum;
    let result = valNum;
    //if (currentIndex === 1 && fromEnd) result = 999;
    return result;
  }



  const handleCancel = () => {
    props.sendCommand({ action: "cancelSubset", parameter: "" })
  }

  const handleSave = () => {
    props.sendCommand({ action: "updateSubset", parameter: playlistMessage })
  }

  const updateStartEndText = () => {
    const startVal = parseFloat(getStartCountValue());
    const endVal = parseFloat(getEndCountValue());

    let startChanged = startVal !== parseFloat(startText);
    if (startVal === 1 && startText === "") startChanged = false;
    if (startChanged) setStartText(getStartCountValue());

    let endChanged = endVal !== parseFloat(endText);
    if (endVal === 1 && endText === "") endChanged = false;
    if (endChanged) setEndText(getEndCountValue());
  }

  const init = () => {
    if (props.playlistMessage) {
      setPlaylistMessage(props.playlistMessage);
    }
  }

  React.useEffect(init, [props.playlistMessage]);
  React.useEffect(updateStartEndText, [playlistMessage]); //eslint-disable-line

  const getStartCountValue = () => { return Math.abs(playlistMessage?.childPlaylistStart).toString(); }
  const getEndCountValue = () => { return Math.abs(playlistMessage?.childPlaylistEnd).toString(); }


  return (
    <>
      <InputBox headerIcon="fas fa-equals" headerText="Playlist subset" saveText="Update" cancelFunction={handleCancel} saveFunction={handleSave} >
        <Row>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Start</FormLabel>
              <FormControl id="startCount" value={startText} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>End</FormLabel>
              <FormControl id="endCount" value={endText} onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>

      </InputBox>

      <SubsetPreview playlistMessage={playlistMessage} />
    </>
  );
};